import React from 'react';
import { ReservationPane } from '../../atoms/reservations/ReservationPane';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './reservationCancelCompletePane.module.scss';
import { SheModal } from '../../../../commonv3/components/molecules/layout/SheModal';

type Props = {
  onPrimaryButtonClick: () => Promise<void>;
  buttonText: string;
  onRequestClose: () => Promise<void>;
  isShowFormThanksMessage: boolean;
};

export const ReservationCancelCompletePane = ({
  onPrimaryButtonClick,
  buttonText,
  onRequestClose,
  isShowFormThanksMessage,
}: Props) => (
  <SheModal open={true} onRequestClose={onRequestClose} id="reservation-cancel-complete-pane">
    <ReservationPane styleName="pane">
      <div styleName="text">
        {isShowFormThanksMessage && (
          <>
            ご回答ありがとうございました。
            <br />
          </>
        )}
        予約キャンセルが完了しました。
        <br />
        公式LINE宛のご連絡は不要です。
        <br />
        どうぞご安心ください。
      </div>
      <div styleName="button-wrapper">
        <Button
          id="cancel-complete-primary-button"
          type="primary"
          size="m"
          disabled={false}
          onClick={onPrimaryButtonClick}
        >
          {buttonText}
        </Button>
      </div>
    </ReservationPane>
  </SheModal>
);
